<template>
  <v-app id="inspire">
    <div v-if="exibe === true">
      <home></home>
      <!-- <app-main></app-main> -->
    </div>
    <div v-else>
      <v-login></v-login>
    </div>
  </v-app>
</template>

<script>
  // import { AppMain } from './components/layout/'
  import store from './store'
  import Home from './components/Home'
  import VLogin from './views/auth/Login'
  export default {
    components: {
      Home,
      VLogin
    },
    data () {
      return {
        exibe: true,
        isMobile: false,
        isTablet: false
      }
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      // this.$vuetify.theme.primary = '#4caf50'
      // console.log(this.$vuetify.theme.secondary)
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    methods: {
      onResize () {
        // this.isMobile = window.innerWidth < 600
        if ((window.innerWidth < 600)) {
          this.isMobile = true
          this.isTablet = false
        } else if ((window.innerWidth > 600) && (window.innerWidth < 960)) {
          this.isMobile = false
          this.isTablet = true
        } else if ((window.innerWidth > 960)) {
          this.isTablet = false
          this.isMobile = false
        }
        store.dispatch('app/setDevice', { mobile: this.isMobile, tablet: this.isTablet }).then(() => {
          // console.log()
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style>
  a:link
  {
    text-decoration:none;
  }
  .backgroud-logo-ipo {
    background-color: #fff;
  }
  .backgroud-logo-alticlin {
    background-color: #d32f2f;
  }
  .backgroud-logo-spitzer {
    background-color: #fff;
  }
  .backgroud-logo-iguacu {
    background-color: #fff;
  }
  .backgroud-logo-ophtalmus {
    background-color: #303F9F;
  }
  .backgroud-logo-barigui {
    background-color: #fff;
  }
  .backgroud-logo-proctoclin {
    background-color: #fff;
  }
  .backgroud-logo-cliniderma {
    background-color: #fff;
  }
  .backgroud-logo-hosp-saolucas {
    background-color: #fff;
  }
  .backgroud-logo-adel-bark {
    background-color: #fff;
  }
  .backgroud-logo-otorrinos {
    background-color: #fff;
  }
  .backgroud-logo-porto-seguro {
    background-color: #fff;
  }
  .backgroud-logo-garden-ouro {
    background-color: #fff;
  }
  .backgroud-logo-oftalmoclinica-curitiba {
    background-color: #fff;
  }
  .backgroud-logo-alcides-branco {
    background-color: #fff;
  }
  .backgroud-logo-instituto-crianca {
    background-color: #fff;
  }
  .backgroud-logo-costa-claro {
    background-color: #fff;
  }
  .backgroud-logo-inga-coi {
    background-color: #fff;
  }
  .backgroud-logo-poli-fazenda {
    background-color: #fff;
  }
  .backgroud-logo-poli-fazenda {
    background-color: #fff;
  }
  .backgroud-logo-artro {
    background-color: #303F9F;
  }
  /*
  #inspire {
    background: url(spitzer_fundo.png) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    ipo 880E4F
  }
  */
</style>



// WEBPACK FOOTER //
// src/App.vue